export const GRID_WIDTH = 20;
export const GRID_HEIGHT = 12;
export const CELL_SIZE = 64;
export const CANVAS_WIDTH = GRID_WIDTH * CELL_SIZE;
export const CANVAS_HEIGHT = GRID_HEIGHT * CELL_SIZE;

export const EntityColors: { [key: string]: number } = {
  // Base Entities
  PHANTOM: 0x00FFFF,
  PORTAL: 0xFF00FF,
  BARRIER: 0x4169E1,
  ORB: 0xFFD700,
  CRYSTAL: 0x00FF00,
  ROCK: 0x8B4513,
  WATER: 0x1E90FF,
  FIRE: 0xFF4500,
  KEY: 0xFFD700,
  DOOR: 0x8B4513,
  
  // Advanced Entities
  ICE: 0xB0E0E6,      // Powder Blue
  LAVA: 0xFF4500,     // Orange Red
  MIRROR: 0xC0C0C0,   // Silver
  VOID: 0x000000,     // Black
  BOLT: 0xFFFF00,     // Yellow
  STAR: 0xFFD700,     // Gold
  SKULL: 0xFFFFFF,    // White
  COIN: 0xFFD700,     // Gold
  GHOST: 0xE0E0E0,    // Light Gray
  STATUE: 0x808080,   // Gray
  
  // Enemy Entities
  HUNTER: 0xDC143C,   // Crimson
  WATCHER: 0x8B008B,  // Dark Magenta
  SHADOW: 0x2F4F4F,   // Dark Slate Gray
  PURSUER: 0xFF6347,  // Tomato
  SENTINEL: 0x4169E1, // Royal Blue
  
  // Word Nouns (Base)
  WORD_PHANTOM: 0x00FFFF,
  WORD_PORTAL: 0xFF00FF,
  WORD_BARRIER: 0x6495ED,
  WORD_ORB: 0xFFD700,
  WORD_CRYSTAL: 0x00FF00,
  WORD_ROCK: 0x8B4513,
  WORD_WATER: 0x1E90FF,
  WORD_FIRE: 0xFF4500,
  WORD_KEY: 0xFFD700,
  WORD_DOOR: 0x8B4513,
  
  // Word Nouns (Advanced)
  WORD_ICE: 0xB0E0E6,
  WORD_LAVA: 0xFF4500,
  WORD_MIRROR: 0xC0C0C0,
  WORD_VOID: 0x444444,
  WORD_BOLT: 0xFFFF00,
  WORD_STAR: 0xFFD700,
  WORD_SKULL: 0xFFFFFF,
  WORD_COIN: 0xFFD700,
  WORD_GHOST: 0xE0E0E0,
  WORD_STATUE: 0x808080,
  
  // Word Nouns (Enemies)
  WORD_HUNTER: 0xDC143C,
  WORD_WATCHER: 0x8B008B,
  WORD_SHADOW: 0x2F4F4F,
  WORD_PURSUER: 0xFF6347,
  WORD_SENTINEL: 0x4169E1,
  
  // Word Connector
  WORD_IS: 0xFFFFFF,
  
  // Word Properties (Base)
  WORD_YOU: 0x00FFFF,
  WORD_WIN: 0x00FF00,
  WORD_STOP: 0xFF1493,
  WORD_PUSH: 0x9370DB,
  WORD_PHASE: 0x7B68EE,
  WORD_SINK: 0x1E90FF,
  WORD_HOT: 0xFF4500,
  WORD_MELT: 0xFFD700,
  WORD_OPEN: 0x00FF00,
  WORD_SHUT: 0xFF0000,
  WORD_MOVE: 0x00FFFF,
  WORD_DEFEAT: 0xFF0000,
  WORD_TRANSFORM: 0xFF00FF,
  
  // Word Properties (Advanced)
  WORD_FLOAT: 0x87CEEB,    // Sky Blue
  WORD_SLIP: 0xADD8E6,     // Light Blue
  WORD_TELE: 0x9370DB,     // Medium Purple
  WORD_CLONE: 0x00CED1,    // Dark Turquoise
  WORD_SWAP: 0xFF69B4,     // Hot Pink
  WORD_WEAK: 0xFFA07A,     // Light Salmon
  WORD_STRONG: 0x4682B4,   // Steel Blue
  WORD_PULL: 0xDC143C,     // Crimson
  WORD_FALL: 0x8B4513,     // Saddle Brown
  WORD_REVERSE: 0xFF1493,  // Deep Pink
  
  // Word Properties (Enemy Behaviors)
  WORD_HUNT: 0xFF4500,     // Orange Red
  WORD_TRACK: 0x9370DB,    // Medium Purple
  WORD_MIMIC: 0x8B008B,    // Dark Magenta
  WORD_GUARD: 0x4169E1,    // Royal Blue
  WORD_ALERT: 0xFFD700     // Gold
};

export const DIMENSION_COLORS = ['', '#00FFFF', '#FF00FF', '#00FF00', '#FFAA00'];
